export default "__VITE_ASSET__CGqCNJ_5__"